import { Checkbox, CheckboxProps } from "@mui/material";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

interface Props extends CheckboxProps {
	ariaLabel?: string;
}

const DefaultCheckbox: React.FC<Props> = ({ ariaLabel = "", ...checkboxProps }) => {

	const accessibility = useAccessibility();

  return (
    <Checkbox
			tabIndex={0}
			color="primary"
			indeterminate={false}
			style={accessibility.contrastColorAccessibility}
			inputProps={{
					'aria-label': ariaLabel,
			}}
			{ ...checkboxProps }
		/>
  )
}

export default DefaultCheckbox;